var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnPreEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2795 0.679688H5.98953C2.69239 0.679688 0.0195312 3.35252 0.0195312 6.64966V21.9397C0.0195312 25.2368 2.69239 27.9097 5.98953 27.9097H21.2795C24.5767 27.9097 27.2495 25.2368 27.2495 21.9397V6.64966C27.2495 3.35252 24.5767 0.679688 21.2795 0.679688Z",
    fill: "#0D5CDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9208 4C19.2508 4 21.1408 5.88997 21.1408 8.21997V20.37C21.1408 22.7 19.2508 24.59 16.9208 24.59H10.5208C8.19078 24.59 6.30078 22.7 6.30078 20.37V10.31L12.8608 4.01001H16.9108L16.9208 4Z",
    fill: "white",
    stroke: "#0D5CDD",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66055 10.3H6.31055L12.8705 4V6.07996C12.8705 8.40996 10.9805 10.3 8.65054 10.3H8.66055Z",
    fill: "white",
    stroke: "#0D5CDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5249 9.43307L23.1596 8.95711C22.9107 8.63292 22.4462 8.57185 22.122 8.8207L10.842 17.4792C10.5178 17.7281 10.4568 18.1926 10.7056 18.5168L11.071 18.9928C11.3198 19.317 11.7843 19.378 12.1085 19.1292L23.3885 10.4706C23.7127 10.2218 23.7738 9.75726 23.5249 9.43307Z",
    fill: "white",
    stroke: "#0D5CDD",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9008 18.7598L9.30078 19.8297",
    stroke: "#0D5CDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnPreEdit);
export default __webpack_public_path__ + "static/media/btn_pre_edit.fd528c01d113e772ddf7bff367720a2e.svg";
export { ForwardRef as ReactComponent };